var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBorderMiddleWood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600.2 349.2",
    style: {
      enableBackground: "new 0 0 1600.2 349.2"
    },
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#730E16;}\n\t.st1{opacity:0.3;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73,682.5 53.6,702.5 34.3,682.5 34.3,-123.2 53.6,-143.2 73,-123.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.6,702.5 73,682.5 73,-123.2 53.6,-143.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1527.3,-167.5 1546.7,-187.5 1566.1,-167.5 1566.1,638.2 1546.7,658.2 1527.3,638.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1546.7,-187.5 1527.3,-167.5 1527.3,638.2 1546.7,658.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBorderMiddleWood);
export default __webpack_public_path__ + "static/media/certificate-border-middle-wood.f1731c24c3fc962678c7c3774c3967d9.svg";
export { ForwardRef as ReactComponent };